import { render, staticRenderFns } from "./QuestionSurvey.vue?vue&type=template&id=6cfa9202"
import script from "./QuestionSurvey.vue?vue&type=script&lang=ts"
export * from "./QuestionSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports